/* eslint-disable no-param-reassign, max-lines */
import TwoFactorAuthHandlerBase from "components/jiffy/vue-print-cart/address-section/twoFactorAuthUtils";

/**
 * Handler class for two-factor authentication operations
 * Extends base handler to provide address editor specific functionality
 */
class TwoFactorAuthHandler extends TwoFactorAuthHandlerBase {
  /**
   * Creates a new TwoFactorAuthHandler instance
   * @param {Object} context - The context object containing required dependencies
   * @param {Function} context.saveAddress - Function to save address data
   * @param {Function} context.setLoading - Function to set loading state
   * @param {Element} context.errorMessageElement - DOM element for error messages
   */
  constructor(context) {
    super(context);

    this.saveAddress = context.saveAddress;
    this.setLoading = context.setLoading;
    this.$errorMessageElement = context.errorMessageElement;
  }

  /**
   * Hides the 2FA modal by clearing timers, resetting form, and hiding the modal
   * @param {HTMLElement} $modal - The modal element to hide
   */
  hideModal($modal) {
    try {
      TwoFactorAuthHandler.clearModalTimer($modal);
      TwoFactorAuthHandler.hideModalElement($modal);
    } catch {
      $modal.style.display = "none";
    } finally {
      this.setLoading(false);
    }
  }

  /**
   * Handles successful verification by saving address and updating state
   * @param {HTMLElement} $modal - The modal element
   * @param {string} authToken - The authentication token from successful verification
   * @returns {Promise<void>}
   * @private
   */
  async handleVerificationSuccess($modal, authToken) {
    this.hideModal($modal);
    TwoFactorAuthHandler.resetModalForm($modal);
    this.saveAddress(authToken);
  }
}

export default TwoFactorAuthHandler;
